// 隐藏入口： IP地址，导入答卷，导出记录，版本记录
// export const hidSurveyId = [
//     'JiV88mAg', 
//     'QczoqFiC', 
//     'yggupKbX', 
//     '6Ts6mDeG', 
//     'Tmlt0nPh', 
//     'Odj5cEKI', 
//     'mbCjrd4v', 
//     'O312rKW4', 
//     'A4xxJrIm', 
//     '35mAQC78', //11月
//     'VJO9xOzE', //12月
//     'URhiCjMc', // 1月

//     'ZHVAkhGC', //其他项目，同样需求
//     'uqMkID0D', //其他项目，同样需求
//     'DJ8ySHUe', //其他项目，同样需求
// ]
// export const hidSurveyId = ["gIhBm0Xq", "lrpXZhqH", "oB0Lsf8N", "kRMkz7lI", "mP428x24", "KV7nuFzz", "JiV88mAg", "QczoqFiC", "yggupKbX", "6Ts6mDeG", "Tmlt0nPh", "Odj5cEKI", "mbCjrd4v", "O312rKW4", "A4xxJrIm", "35mAQC78", "VJO9xOzE", "URhiCjMc"]
// 隐藏入口：下载录音，下载多媒体文件
export const hidAccount = ['18285604762']

//显示录音转文字
export const showAudioToTextSurveyIds = ['8zCvQ3pM']